export class UnderwriterApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createUnderwriterVerify(body) {
    return this.#http.post('/underwriter/verify', body);
  }

  async createUnderwriterSpecificScenarioVerify(body) {
    return this.#http.post('/underwriter/specificScenario/verify', body);
  }
}
